'use strict';

import DebugActionTypes from '../constants/DebugActionTypes';
import omit from 'lodash/object/omit';

let lastLogTime;

function logAction(prefix, action) {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  const breakLine = Date.now() - lastLogTime > 1000;
  lastLogTime = Date.now();

  let method = 'log';
  if (action.type && action.type.substr(-6) === '_ERROR') {
    method = 'error';
  } else if (action.type && DebugActionTypes.indexOf(action.type) !== -1) {
    method = 'debug';
  }

  if (breakLine) {
    console[method].call(console, '\n');
  }

  console[method].call(console, prefix, action.type, omit(action, 'type'));
}

export default logAction;


/** WEBPACK FOOTER **
 ** ./utils/logAction.js
 **/